import { createContext, useContext } from 'react';

const FeatureContext = createContext(null);

const FeatureProvider = FeatureContext.Provider;
const useFeatureContext = () => useContext(FeatureContext);

export { FeatureProvider, useFeatureContext, FeatureContext };
